import { getProductHistory } from '@/api/product';
import { useTable } from '@/hooks/useTable';
import { Drawer, Table } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { useAtomValue } from 'jotai';
import { commonOptionsAtom, CommonOption } from '@/atoms/commonOptions';

interface ProductHistoryDrawerProps {
  open: boolean;
  onClose: () => void;
  productStockId?: number;
}

const ProductHistoryDrawer: React.FC<ProductHistoryDrawerProps> = ({
  open,
  onClose,
  productStockId,
}) => {
  const { data, total, currentPage, pageSize, isLoading, handleTableChange } =
    useTable({
      queryKey: ['product', 'history', productStockId].join(','),
      queryFn: async (currentPage = 1, pageSize = 20) => {
        if (!productStockId) return { list: [], total: 0 };
        const res = await getProductHistory({
          productStockId,
          currentPage,
          pageSize,
          // fieldType: '',
        });
        return res.data;
      },
    });

  const commonOptions = useAtomValue(commonOptionsAtom);

  const columns = [
    {
      title: '字段类型',
      dataIndex: 'fieldType',
      width: 160,
      ellipsis: true,
      render: (value: number) => {
        // 从 productUpdateFieldTypes 中查找对应的文本
        const option = commonOptions.productUpdateFieldTypes.find(
          (item: CommonOption) => item.value === value
        );
        return option ? option.text : value.toString();
      },
    },
    {
      title: '更新前',
      dataIndex: 'updateBefore',
      width: 200,
    },
    {
      title: '更新后',
      dataIndex: 'updateAfter',
      width: 200,
    },
    {
      title: '操作人',
      dataIndex: 'createUser',
      width: 120,
    },
    {
      title: '操作时间',
      dataIndex: 'createTime',
      width: 160,
      render: (time: number) => dayjs(time).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return (
    <Drawer
      title="商品历史记录"
      placement="right"
      width={800}
      onClose={onClose}
      open={open}
      maskClosable={false}
    >
      <Table
        columns={columns}
        dataSource={data}
        rowKey="createTime"
        loading={isLoading}
        pagination={{
          total,
          current: currentPage,
          pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
        }}
        onChange={handleTableChange}
      />
    </Drawer>
  );
};

export default ProductHistoryDrawer;
